import {
    PAYMENT_PAGE_TYPE,
} from 'entities/payment-methods/constants';

export function formatClientFieldsError(paymentPageType: PAYMENT_PAGE_TYPE): string | null {
    switch (paymentPageType) {
        case PAYMENT_PAGE_TYPE.DEFAULT:
        case PAYMENT_PAGE_TYPE.UPI_INTENT_QR: {
            return 'This UTR already exists';
        }
        case PAYMENT_PAGE_TYPE.UPI_P2P: {
            return 'Not unique client fields values';
        }
    }
}
